import { render, staticRenderFns } from "./lezioniList.vue?vue&type=template&id=6d87e141&"
import script from "./lezioniList.vue?vue&type=script&lang=ts&"
export * from "./lezioniList.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports